import { render, staticRenderFns } from "./FulfillOrders.vue?vue&type=template&id=568504dd&scoped=true"
import script from "./FulfillOrders.vue?vue&type=script&lang=js"
export * from "./FulfillOrders.vue?vue&type=script&lang=js"
import style0 from "./FulfillOrders.vue?vue&type=style&index=0&id=568504dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568504dd",
  null
  
)

export default component.exports